import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResults = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 334,
	height: 175,
	viewBox: "0 0 153 133",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6475_55)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_6475_55",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 0,
					y: 17,
					width: 153,
					height: 115,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M152.888 17.0449H0V131.994H152.888V17.0449Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask0_6475_55)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M99.9634 25.8462H6.07315C3.22311 25.8462 0.912704 28.1668 0.912704 31.0294V54.4162C0.912704 57.2788 3.22311 59.5994 6.07315 59.5994H99.9634C102.813 59.5994 105.124 57.2788 105.124 54.4162V31.0294C105.124 28.1668 102.813 25.8462 99.9634 25.8462Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M105.124 46.9715V57.5773C105.124 58.6946 102.883 59.599 100.135 59.599H5.90813C3.15168 59.599 0.918823 58.6946 0.918823 57.5773V51.4385C7.27107 53.1287 14.5034 54.2685 21.9212 54.9765C30.8852 55.8318 40.1243 56.0815 49.3247 56.1183C60.326 56.1633 71.5107 55.8953 81.8662 54.3954C91.3559 53.0244 100.155 50.4972 105.124 46.9715Z",
							fill: "#DAE9ED"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M99.8656 60.4566H5.97535C4.39145 60.455 2.87283 59.8225 1.75265 58.6976C0.632459 57.573 0.0021571 56.0479 0 54.457V31.0681C0.0021571 29.4773 0.632459 27.9522 1.75265 26.8274C2.87283 25.7027 4.39145 25.0701 5.97535 25.0685H99.8656C101.45 25.0701 102.969 25.703 104.089 26.8282C105.209 27.9533 105.839 29.479 105.841 31.0702V54.459C105.838 56.0496 105.208 57.574 104.088 58.6985C102.967 59.8227 101.449 60.455 99.8656 60.4566ZM5.97535 26.7055C4.82353 26.7066 3.71916 27.1665 2.90451 27.9844C2.08987 28.8022 1.63144 29.9113 1.62983 31.0681V54.457C1.63091 55.6141 2.08909 56.7238 2.9038 57.5421C3.71851 58.3604 4.82319 58.8206 5.97535 58.8216H99.8656C101.018 58.8206 102.123 58.3604 102.937 57.5421C103.752 56.7238 104.21 55.6141 104.211 54.457V31.0681C104.21 29.9109 103.752 28.8014 102.937 27.9831C102.123 27.1648 101.018 26.7046 99.8656 26.7035L5.97535 26.7055Z",
							fill: "#A096B1"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M147.025 78.2307H39.7026C36.8526 78.2307 34.5421 80.5511 34.5421 83.4138V106.801C34.5421 109.663 36.8526 111.984 39.7026 111.984H147.025C149.875 111.984 152.185 109.663 152.185 106.801V83.4138C152.185 80.5511 149.875 78.2307 147.025 78.2307Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M152.185 99.3559V109.962C152.185 111.079 149.663 111.983 146.552 111.983H40.1752C37.0643 111.983 34.5421 111.079 34.5421 109.962V103.823C41.7134 105.513 49.8788 106.653 58.2521 107.361C68.3611 108.216 78.8001 108.466 89.1882 108.503C101.603 108.548 114.235 108.28 125.925 106.78C136.643 105.409 146.576 102.882 152.185 99.3559Z",
							fill: "#DAE9ED"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M77.0745 78.3145C65.9917 78.9816 50.5898 78.3371 41.0329 80.7905C36.4959 81.9528 35.3774 84.2078 34.646 86.0719L34.6603 80.8519C34.6603 80.1828 34.7235 79.4543 35.9275 78.9428C37.4167 78.3125 40.0306 78.2634 42.3327 78.2654C53.6356 78.2695 65.9958 77.8194 77.0745 78.3145Z",
							fill: "#4ED9FF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M147.202 112.841H39.8782C38.2942 112.84 36.7756 112.207 35.6555 111.082C34.5352 109.958 33.9051 108.433 33.9028 106.842V83.4529C33.9045 81.8617 34.5346 80.336 35.6547 79.211C36.775 78.0857 38.294 77.4528 39.8782 77.4512H147.202C148.786 77.4528 150.305 78.0857 151.426 79.211C152.546 80.336 153.176 81.8617 153.178 83.4529V106.842C153.175 108.433 152.545 109.958 151.425 111.082C150.305 112.207 148.786 112.84 147.202 112.841ZM39.8782 79.0902C38.7263 79.0913 37.6221 79.5513 36.8074 80.3691C35.9927 81.187 35.5343 82.2959 35.5327 83.4529V106.842C35.5337 107.999 35.9919 109.109 36.8066 109.927C37.6213 110.745 38.7261 111.205 39.8782 111.206H147.202C148.354 111.205 149.459 110.745 150.274 109.927C151.089 109.109 151.547 107.999 151.548 106.842V83.4529C151.547 82.2957 151.089 81.186 150.274 80.3677C149.459 79.5494 148.354 79.0894 147.202 79.0882L39.8782 79.0902Z",
							fill: "#A096B1"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 20,
							y: 18.0449,
							width: 117,
							height: 106,
							rx: 4,
							fill: "#ECEAF1"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M132.285 125.262H24.9753C23.3911 125.26 21.8721 124.627 20.7518 123.502C19.6317 122.377 19.0016 120.851 19 119.26V23.0466C19.0016 21.4554 19.6317 19.9298 20.7518 18.8046C21.8721 17.6794 23.3911 17.0465 24.9753 17.0449H132.285C133.869 17.0465 135.388 17.6794 136.509 18.8046C137.629 19.9298 138.259 21.4554 138.261 23.0466V119.262C138.258 120.853 137.628 122.378 136.508 123.503C135.388 124.627 133.869 125.26 132.285 125.262ZM24.9753 18.6819C23.8232 18.683 22.7184 19.1432 21.9037 19.9615C21.089 20.7798 20.6309 21.8894 20.6298 23.0466V119.262C20.6309 120.419 21.089 121.529 21.9037 122.347C22.7184 123.165 23.8232 123.626 24.9753 123.627H132.285C133.437 123.626 134.542 123.165 135.357 122.347C136.171 121.529 136.63 120.419 136.631 119.262V71.1543V23.0466C136.63 21.8894 136.171 20.7798 135.357 19.9615C134.542 19.1432 133.437 18.683 132.285 18.6819H24.9753Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M123.861 24.6081H33.5235C31.739 24.6081 30.2924 26.0611 30.2924 27.8535V113.132C30.2924 114.924 31.739 116.377 33.5235 116.377H123.861C125.645 116.377 127.092 114.924 127.092 113.132V27.8535C127.092 26.0611 125.645 24.6081 123.861 24.6081Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M126.923 27.2222V43.0325H30.1518V27.2222C30.1518 26.0094 31.5367 25.0254 33.2453 25.0254H123.829C125.538 25.0254 126.923 26.0094 126.923 27.2222Z",
							fill: "#DAE9ED"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M124.032 117.706H33.6989C32.626 117.704 31.5976 117.276 30.8391 116.514C30.0805 115.752 29.6539 114.719 29.6528 113.642V27.6986C29.6545 26.6214 30.0813 25.5889 30.8398 24.8275C31.5982 24.066 32.6265 23.6378 33.6989 23.6367H124.032C125.105 23.6378 126.133 24.0663 126.892 24.8282C127.65 25.5901 128.077 26.6231 128.078 27.7006V113.644C128.076 114.721 127.65 115.753 126.891 116.515C126.133 117.276 125.104 117.704 124.032 117.706ZM33.6989 25.2737C33.0584 25.2748 32.4443 25.5309 31.9914 25.9857C31.5385 26.4406 31.2837 27.0573 31.2827 27.7006V113.644C31.2843 114.287 31.5394 114.903 31.9922 115.357C32.4451 115.812 33.0588 116.067 33.6989 116.068H124.032C124.673 116.067 125.286 115.811 125.739 115.356C126.192 114.902 126.447 114.285 126.448 113.642V27.6986C126.447 27.0556 126.192 26.4395 125.739 25.985C125.286 25.5306 124.672 25.2748 124.032 25.2737H33.6989Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M117.755 36.8937H39.3196V40.3723H117.755V36.8937Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 53.8224H59.9124V52.9732H39.7698V53.8224Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 55.6929H83.6101V54.8437H39.7698V55.6929Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 57.5634H59.9124V56.7142H39.7698V57.5634Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 59.4328H83.6101V58.5836H39.7698V59.4328Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 61.3033H59.9124V60.4541H39.7698V61.3033Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 63.1722H83.6101V62.323H39.7698V63.1722Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 70.7225H59.9124V69.8733H39.7698V70.7225Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 72.593H83.6101V71.7438H39.7698V72.593Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 74.4635H59.9124V73.6143H39.7698V74.4635Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 76.3329H83.6101V75.4837H39.7698V76.3329Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 78.2034H59.9124V77.3542H39.7698V78.2034Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 80.0723H83.6101V79.2231H39.7698V80.0723Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 87.6226H59.9124V86.7734H39.7698V87.6226Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 89.4931H83.6101V88.6439H39.7698V89.4931Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 91.3634H59.9124V90.5142H39.7698V91.3634Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 93.233H83.6101V92.3838H39.7698V93.233Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 95.1035H59.9124V94.2543H39.7698V95.1035Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.7698 96.9724H83.6101V96.1232H39.7698V96.9724Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M107.764 29.4365C107.764 29.9298 108.164 30.3297 108.657 30.3297H121.992C122.485 30.3297 122.885 29.9298 122.885 29.4365C122.885 28.9432 122.485 28.5433 121.992 28.5433H108.657C108.164 28.5433 107.764 28.9432 107.764 29.4365Z",
							fill: "#EEA248"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M90.5573 29.4365C90.5573 29.9298 90.9571 30.3297 91.4504 30.3297H104.785C105.278 30.3297 105.678 29.9298 105.678 29.4365C105.678 28.9432 105.278 28.5433 104.785 28.5433H91.4504C90.9571 28.5433 90.5573 28.9432 90.5573 29.4365Z",
							fill: "#EEA248"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M34.9415 31.1578C35.8888 31.1578 36.6568 30.3864 36.6568 29.4348C36.6568 28.4833 35.8888 27.7119 34.9415 27.7119C33.9941 27.7119 33.2261 28.4833 33.2261 29.4348C33.2261 30.3864 33.9941 31.1578 34.9415 31.1578Z",
							fill: "#EEA248"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M95.5861 94.0333L90.1164 99.2431L101.215 110.998L106.685 105.788L95.5861 94.0333Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsxs("g", {
							opacity: .5,
							children: [/* @__PURE__ */ _jsx("path", {
								opacity: .5,
								d: "M90.8406 94.2193C97.9689 87.4298 98.2678 76.1218 91.5078 68.9621C84.7481 61.8024 73.4897 61.5022 66.3615 68.2917C59.2332 75.0814 58.9343 86.3895 65.694 93.5492C72.454 100.709 83.7124 101.009 90.8406 94.2193Z",
								fill: "#E3DFE9"
							}), /* @__PURE__ */ _jsx("path", {
								opacity: .5,
								d: "M69.2269 91.5799C67.428 89.6756 66.0693 87.3965 65.2475 84.9045C64.4257 82.4128 64.1608 79.7694 64.4721 77.1631C64.7834 74.5568 65.6629 72.0515 67.0483 69.8254C68.4334 67.5995 70.2904 65.7077 72.4866 64.2847C70.1366 65.1497 67.9948 66.5031 66.2011 68.2563C64.4075 70.0096 63.0024 72.1232 62.0779 74.4592C61.1532 76.7952 60.7296 79.3008 60.8352 81.8124C60.9405 84.324 61.5724 86.785 62.6897 89.0345C63.8067 91.284 65.384 93.2715 67.3182 94.8668C69.2524 96.4622 71.4999 97.6296 73.9141 98.2928C76.3283 98.956 78.8545 99.1001 81.3278 98.7156C83.8012 98.3311 86.1659 97.4264 88.2674 96.0612C85.0047 97.264 81.4629 97.4807 78.0791 96.6843C74.6952 95.8879 71.6179 94.1133 69.2269 91.5799Z",
								fill: "#6B6770"
							})]
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M98.0137 62.1816C96.0752 60.1237 93.8316 58.3795 91.362 57.0107C91.3192 56.9841 91.2764 56.9616 91.2296 56.9391C85.5203 53.8163 78.8916 52.8347 72.5281 54.1695C66.1644 55.5045 60.481 59.0688 56.4935 64.2258C52.5059 69.3826 50.4743 75.7958 50.7618 82.3191C51.0492 88.8422 53.637 95.0499 58.0626 99.8329C58.1257 99.9045 58.1909 99.974 58.2663 100.037C60.2899 102.186 62.6463 103.992 65.244 105.384L65.3173 105.423C71.0582 108.473 77.6912 109.375 84.0329 107.968C90.3745 106.562 96.0123 102.937 99.9402 97.7426C103.868 92.5478 105.831 86.1202 105.478 79.6068C105.125 73.0933 102.48 66.9177 98.0137 62.1816ZM91.3131 68.9629C93.734 71.5269 95.3436 74.7543 95.9383 78.2368C96.533 81.7195 96.0862 85.3013 94.6544 88.5289C93.2224 91.7565 90.87 94.4852 87.8939 96.3698C84.9181 98.2546 81.4526 99.2104 77.9359 99.1169C74.4189 99.0234 71.0087 97.8844 68.1363 95.8441C65.264 93.8037 63.0586 90.9539 61.7987 87.6545C60.5391 84.3553 60.2816 80.7549 61.0592 77.3088C61.8366 73.8625 63.6142 70.7254 66.1669 68.2938C67.8617 66.6793 69.8566 65.4159 72.0377 64.5757C74.2188 63.7358 76.5432 63.3355 78.8783 63.3977C81.2135 63.4601 83.5135 63.9838 85.647 64.939C87.7806 65.8944 89.7059 67.2623 91.3131 68.965V68.9629Z",
							fill: "#ECEAF1"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M99.9349 97.1402C95.2836 101.571 89.2324 104.223 82.8349 104.634C76.4375 105.046 70.0991 103.191 64.9229 99.3919C59.747 95.593 56.0614 90.0912 54.5077 83.8444C52.9543 77.5975 53.6311 71.0014 56.4205 65.2041C54.1657 68.287 52.5754 71.8085 51.7515 75.5433C50.9278 79.2783 50.8883 83.1448 51.636 86.8958C52.3835 90.6468 53.9014 94.2001 56.0931 97.3288C58.2849 100.458 61.102 103.093 64.3647 105.066C67.6274 107.04 71.264 108.309 75.0421 108.791C78.8205 109.274 82.6575 108.96 86.3081 107.869C89.9587 106.779 93.343 104.936 96.2445 102.458C99.146 99.9796 101.501 96.921 103.16 93.4774C102.195 94.7915 101.115 96.0172 99.9349 97.1402Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M78.3662 109.591C73.6759 109.594 69.0602 108.413 64.9425 106.158L64.8406 106.102C58.8604 102.798 54.2704 97.4338 51.9161 90.9989C51.8631 90.8598 51.8122 90.7145 51.7653 90.5651C49.9057 85.1906 49.6997 79.3782 51.1747 73.8846C52.6495 68.391 55.7368 63.4707 60.0347 59.7639C64.3325 56.0571 69.6417 53.7359 75.2713 53.1021C80.9009 52.4682 86.5901 53.5513 91.5983 56.2104C91.6533 56.237 91.7083 56.2677 91.7613 56.2984C97.0334 59.1452 101.267 63.6023 103.851 69.0255C106.434 74.4485 107.233 80.5566 106.132 86.466C105.032 92.3755 102.088 97.78 97.7271 101.898C93.3663 106.016 87.8145 108.634 81.8744 109.374C80.7105 109.518 79.5388 109.591 78.3662 109.591ZM78.413 54.5468C74.1702 54.5482 69.9893 55.5693 66.2195 57.5247C62.4497 59.4801 59.2004 62.313 56.7428 65.7869C54.2855 69.2609 52.6911 73.275 52.0931 77.494C51.4952 81.713 51.9108 86.0144 53.3055 90.0392V90.0638C53.3442 90.1866 53.3891 90.3093 53.4339 90.4301C55.6523 96.4999 59.9817 101.559 65.6229 104.674L65.6943 104.713C71.256 107.769 77.7224 108.727 83.9259 107.414C90.1292 106.102 95.6613 102.606 99.5235 97.5562C103.386 92.5066 105.323 86.2369 104.987 79.8783C104.651 73.5197 102.063 67.4912 97.6898 62.8812C95.7417 60.812 93.4753 59.0711 90.9769 57.7246L90.9464 57.7062L90.8812 57.6714L90.8506 57.6551C87.0197 55.6149 82.7492 54.5499 78.413 54.5529V54.5468ZM78.413 99.935C78.2439 99.935 78.0769 99.935 77.9078 99.935C73.0024 99.8678 68.3225 97.8549 64.8891 94.3354C61.4557 90.8158 59.5474 86.0752 59.5808 81.1478C59.6142 76.2204 61.5863 71.5062 65.0672 68.0339C68.5479 64.5616 73.2546 62.6127 78.1604 62.6127C83.0662 62.6127 87.7729 64.5616 91.2538 68.0339C94.7345 71.5062 96.7066 76.2204 96.74 81.1478C96.7734 86.0752 94.8651 90.8158 91.4317 94.3354C87.9984 97.8549 83.3184 99.8678 78.413 99.935ZM78.3906 64.2031C74.0467 64.1941 69.8668 65.8698 66.7231 68.8809C63.8743 71.5944 62.0506 75.2161 61.5624 79.129C61.0743 83.0418 61.9518 87.0036 64.0457 90.3394C66.1398 93.675 69.3204 96.1784 73.046 97.423C76.7714 98.6673 80.8113 98.5758 84.4772 97.1639C88.1429 95.7522 91.2082 93.1074 93.1501 89.6801C95.0922 86.253 95.7912 82.2555 95.1279 78.3688C94.4646 74.4819 92.48 70.9466 89.5125 68.3646C86.5448 65.7826 82.7779 64.3142 78.8531 64.2092C78.7023 64.2092 78.5501 64.2092 78.3967 64.2092L78.3906 64.2031Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M99.9579 103.687L99.9565 103.688C97.6346 105.9 97.5372 109.583 99.7391 111.916L116.212 129.363C118.414 131.696 122.082 131.793 124.403 129.582L124.405 129.58C126.727 127.369 126.824 123.685 124.622 121.353L108.149 103.905C105.947 101.573 102.28 101.475 99.9579 103.687Z",
							fill: "#7A7A7D"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M120.177 131.994H119.996C119.129 131.974 118.273 131.782 117.48 131.428C116.687 131.075 115.972 130.566 115.375 129.933L98.904 112.483C98.3067 111.85 97.8393 111.106 97.5284 110.292C97.2177 109.478 97.0696 108.61 97.0927 107.739C97.1155 106.867 97.3092 106.009 97.6625 105.212C98.0157 104.416 98.5218 103.697 99.1515 103.098C99.7813 102.498 100.523 102.028 101.333 101.716C102.143 101.404 103.007 101.255 103.875 101.278C104.742 101.301 105.597 101.496 106.39 101.851C107.183 102.205 107.898 102.714 108.496 103.346L124.969 120.791C126.171 122.07 126.819 123.776 126.773 125.534C126.726 127.293 125.988 128.961 124.72 130.175C123.496 131.347 121.869 131.999 120.177 131.994ZM103.698 102.917C102.725 102.919 101.775 103.207 100.963 103.745C100.152 104.283 99.5152 105.048 99.1312 105.945C98.7471 106.843 98.633 107.833 98.8025 108.795C98.9723 109.756 99.4182 110.647 100.086 111.357L116.557 128.804C117.468 129.762 118.72 130.32 120.039 130.356C121.358 130.391 122.637 129.901 123.598 128.992C124.552 128.077 125.108 126.82 125.143 125.495C125.178 124.17 124.69 122.885 123.785 121.92L107.314 104.474C106.849 103.98 106.288 103.588 105.666 103.32C105.044 103.052 104.374 102.915 103.698 102.917Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsxs("g", {
							opacity: .5,
							children: [/* @__PURE__ */ _jsx("path", {
								opacity: .5,
								d: "M105.511 105.869C107.548 107.588 109.123 109.726 111.026 111.576C111.592 112.126 112.452 111.259 111.89 110.708C109.987 108.867 108.412 106.72 106.375 105.001C105.776 104.496 104.908 105.359 105.511 105.869Z",
								fill: "#35363A"
							}), /* @__PURE__ */ _jsx("path", {
								opacity: .5,
								d: "M101.995 105.482C102.321 105.279 102.688 105.151 103.069 105.106C103.45 105.062 103.837 105.102 104.201 105.225C104.957 105.446 105.281 104.261 104.527 104.04C104.005 103.874 103.454 103.823 102.911 103.889C102.368 103.954 101.845 104.136 101.377 104.42C100.703 104.83 101.316 105.888 101.988 105.48L101.995 105.482Z",
								fill: "#35363A"
							})]
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M85.1686 58.8192C88.4181 59.8116 91.474 61.3995 94.0125 63.6647C97.2355 66.5295 99.4276 70.2905 100.768 74.3749C101.013 75.1218 102.194 74.8025 101.948 74.0475C100.544 69.7708 98.2541 65.8031 94.8783 62.793C92.1728 60.3825 88.9417 58.7005 85.4967 57.6323C84.7429 57.4011 84.421 58.5859 85.1707 58.8171L85.1686 58.8192Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M73.2974 57.6798C75.4223 57.3974 77.6246 57.5018 79.7474 57.7187C80.5297 57.7985 80.5236 56.5708 79.7474 56.4909C77.6246 56.274 75.4223 56.1697 73.2974 56.4521C72.5293 56.5544 72.5191 57.7842 73.2974 57.6798Z",
							fill: "#C4BDD2"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31 27.0449C31 25.9404 31.8954 25.0449 33 25.0449H78.8762V33.6392H31V27.0449Z",
					fill: "#C4BDD2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M126.108 27.23C126.108 26.1254 125.212 25.23 124.108 25.23H78.2317V33.8243H126.108V27.23Z",
					fill: "#F6F6F6"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.701 3.63219C18.5988 1.62618 21.7634 1.53842 23.7694 3.43616L36.3693 15.3561C38.3753 17.2539 38.4631 20.4185 36.5654 22.4245L24.1777 35.5188C22.28 37.5248 19.1153 37.6126 17.1093 35.7148L4.5094 23.7949C2.50339 21.8972 2.41563 18.7325 4.31337 16.7265L16.701 3.63219Z",
			fill: "#DAE9ED"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_6475_55)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M20 28.2949C20.8284 28.2949 21.5 27.6233 21.5 26.7949C21.5 25.9665 20.8284 25.2949 20 25.2949C19.1716 25.2949 18.5 25.9665 18.5 26.7949C18.5 27.6233 19.1716 28.2949 20 28.2949Z",
				fill: "black"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M20 12.5449V22.2949",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6475_55",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 153,
				height: 115,
				fill: "white",
				transform: "translate(0 17.0449)"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_6475_55",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 8.04492)"
			})
		})] })
	]
});
export default SvgNoResults;
